import { render } from "./Restore.vue?vue&type=template&id=76245733&scoped=true&lang=pug"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"

import "./Restore.vue?vue&type=style&index=0&id=76245733&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76245733"]])

export default __exports__